import { createReducer } from '@reduxjs/toolkit';
import { lifecycleSurveyTriggerTypesActions } from '~/behaviors/actions/lifecycleSurveyTriggerTypes.actions';

const defaultState = {};

const replaceLifecycleSurveyTriggerTypes = (state, action) => {
  return action?.payload || defaultState;
};

const lifecycleSurveyTriggerTypes = createReducer(defaultState, (builder) => {
  builder.addCase(
    lifecycleSurveyTriggerTypesActions.getLifecycleSurveyTriggerTypes.fulfilled,
    replaceLifecycleSurveyTriggerTypes,
  );
});

// This is related to the lifecycleSurveyTriggerTypeToCompany table
export default lifecycleSurveyTriggerTypes;
